export const selectOptionsExceptionCategory = [
  "Subject Property",
  "Borrower",
  "Leverage",
  "Pricing",
  "Other Guideline",
];
